const { connect } = require('react-redux');
const BrokerCustomWalletSideBar = require ('./brokerCustomWalletSideBar');
// @ actions
const customWalletActions = require('../../actions/customWallet');

module.exports.BrokerCustomWalletSideBar = connect(
    state => ({
        brokerCustomWalletNotifications: state.brokerCustomWalletNotifications
    }),
    {
        init: customWalletActions.init
    }
)(BrokerCustomWalletSideBar);
